import { createSelector } from 'reselect';
import Routes from 'lib/utils/routes';
import { LABS_URL } from 'lib/appConfig';
import { getMachine } from './getMachine';
import { getCompanySettings } from './getCompanySettings';
import { getMachineSettings } from './getMachineSettings';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

const getTabs = (store) => {
  return store.tabs;
};

const getTabConfig = createSelector([getTabs], (tabs) => {
  return tabs.data;
});

const getTabConfigLoading = createSelector([getTabs], (tabs) => {
  return tabs.loading;
});

const getVisibleTabs = createSelector([getTabConfig], (tabs) => {
  return tabs.filter((tab) => {
    return tab.enabled;
  });
});

const getEffectiveVisibleTabs = createSelector(
  [getVisibleTabs, getIsApmERPJobFlow],
  (tabs, isApmERPJobFlow) => {
    if (isApmERPJobFlow) {
      return [{ id: 'jobs', enabled: true }, ...tabs];
    }
    return tabs;
  }
);

const getTabRoutes = createSelector(
  [getEffectiveVisibleTabs, getMachine],
  (tabs, machine) => {
    return tabs.map((tab) => {
      return Routes.machineIdHomeTabPath(machine.id, tab.id);
    });
  }
);

const getHomeTabRoute = createSelector(
  [getEffectiveVisibleTabs, getMachine],
  (tabs, machine) => {
    if (!tabs.length || !machine.id) {
      return null;
    }

    return Routes.machineIdHomeTabPath(machine.id, tabs[0].id);
  }
);

const getHomeTab = createSelector([getEffectiveVisibleTabs], (tabs) => {
  if (!tabs.length) {
    return null;
  }

  return tabs[0].id;
});

const getIsHomeTabContextReady = createSelector(
  [getTabConfigLoading, getCompanySettings, getMachineSettings, getMachine],
  (tabsLoading, companySettings, machineSettings, machine) => {
    if (tabsLoading || !machine?.id) {
      return false;
    }

    if (companySettings == null) {
      return false;
    }

    return machineSettings?.mesEnabled !== undefined;
  }
);

const getVisibleTabIDs = createSelector([getVisibleTabs], (tabs) => {
  return tabs.map((tab) => {
    return tab.id || tab.name;
  });
});

const getHasPartsGoalTab = createSelector([getVisibleTabIDs], (tabs) => {
  return tabs.includes('partsGoal');
});

const getHasDowntimeTab = createSelector([getVisibleTabIDs], (tabs) => {
  return tabs.includes('downtime');
});

const historicalPartsTabs = ['partCount', 'utilization', 'partsGoal', 'oee'];

const getHasAHistoricalPartsTab = createSelector([getVisibleTabIDs], (tabs) => {
  return tabs.some((tab) => {
    return historicalPartsTabs.includes(tab);
  });
});

const getHasLabTab = createSelector([getVisibleTabs], (tabs) => {
  return tabs.some((tab) => {
    return tab.url?.includes(LABS_URL?.replace('https://', ''));
  });
});

export {
  getVisibleTabs,
  getEffectiveVisibleTabs,
  getTabRoutes,
  getHomeTabRoute,
  getHomeTab,
  getIsHomeTabContextReady,
  getTabConfigLoading,
  getTabConfig,
  getHasPartsGoalTab,
  getHasDowntimeTab,
  getHasAHistoricalPartsTab,
  getHasLabTab,
};
